module.exports = __webpack_public_path__ + "static/media/delete.9f663bb2.png";